import { useQuery } from "@tanstack/react-query"
import api from "../../../services/api"


export function useEcommRegionalAnalysis() {
  return useQuery({
    queryKey: ["ecomm-regional_analysis"],
    queryFn: async () => {
      const res = await api.get("/api/shopify/customer_insights/regional_analysis")
      const raw = res.data.regional_analysis

      return raw.map((item: any) => ({
        region: item.continent,
        customers: item.total_customers,
        sales: item.total_sales,
        avgOrderValue: item.avg_order_value,
        percentOfCustomers: item.percent_of_customers
      }))
    }
  })
}
